/**
 * @generated SignedSource<<7b1c57c56867222618348f70699843ec>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Query } from 'relay-runtime';
export type updatePageValveManufacturerQuery$variables = {
  valveManufacturerId: string;
};
export type updatePageValveManufacturerQueryVariables = updatePageValveManufacturerQuery$variables;
export type updatePageValveManufacturerQuery$data = {
  readonly valveManufacturer: {
    readonly id: string;
    readonly createdAt: any;
    readonly name: string;
  } | null;
};
export type updatePageValveManufacturerQueryResponse = updatePageValveManufacturerQuery$data;
export type updatePageValveManufacturerQuery = {
  variables: updatePageValveManufacturerQueryVariables;
  response: updatePageValveManufacturerQuery$data;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "valveManufacturerId"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "valveManufacturerId",
        "variableName": "valveManufacturerId"
      }
    ],
    "concreteType": "ValveManufacturer",
    "kind": "LinkedField",
    "name": "valveManufacturer",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "id",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "createdAt",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "name",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "updatePageValveManufacturerQuery",
    "selections": (v1/*: any*/),
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "updatePageValveManufacturerQuery",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "e49d84e361e825fe3a3c0477b957f1d4",
    "id": null,
    "metadata": {},
    "name": "updatePageValveManufacturerQuery",
    "operationKind": "query",
    "text": "query updatePageValveManufacturerQuery(\n  $valveManufacturerId: ID!\n) {\n  valveManufacturer(valveManufacturerId: $valveManufacturerId) {\n    id\n    createdAt\n    name\n  }\n}\n"
  }
};
})();

(node as any).hash = "310a60185432a5194fa0c979676f5ab4";

export default node;
